<script setup lang="ts">
import Toast from 'primevue/toast';
import DOMPurify from 'dompurify';

function sanitize(input: string) {
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ['b', 'i', 'strong', 'a', 'em', 'br'],
    ALLOWED_ATTR: ['href', 'target'],
  });
}
</script>
<template>
  <Toast position="top-center">
    <template #message="slotProps">
      <div v-html="sanitize(slotProps.message.detail)"></div>
    </template>
  </Toast>
</template>
